/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable object-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';

import withStyles from '@material-ui/core/styles/withStyles';

import Form from '../Form';
import { form as FormStyle } from '../../style/form';
import EventDispatcher from '../../state/reducers/EventDispatcher';

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class CreateAccountForm extends Form {
    state = {
        data: {
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            verifypassword: '',
            specialoffer: true,
        },
        errors: {},
    };

    schema = {
        firstname: Joi.string()
            .trim()
            .max(50)
            .required()
            .label('First Name'),
        lastname: Joi.string()
            .trim()
            .max(50)
            .required()
            .label('Last Name'),
        email: Joi.string()
            .email({ minDomainSegments: 2 })
            .trim()
            .max(50)
            .required()
            .label('Email Address'),
        password: Joi.string()
            .required()
            .min(6)
            .label('Password'),
        verifypassword: Joi.string()
            .required()
            .min(6)
            .label('Verify Password'),
        specialoffer: Joi.boolean(),
    };

    doSubmit = (submitData) => {
        const { data } = this.state;
        data.callBack = { url: '/account' };
        submitData.handleSubmitCreateAccount(data);
    };

    handlePrivacyClicked = () => {
        const data = {
            title: 'Your Privacy',
            content: { url: '/privacy.html' },
            customClass: '',
            layout: 'HTMLContent',
        };

        this.props.handleOpenModal(data);
    };

    render() {
        /* eslint-disable max-len */
        const { classes, handleSubmitCreateAccount } = this.props;
        // const { data } = this.state;
        const submitData = { handleSubmitCreateAccount };

        return (
            <>
                <h1>Create your FREE account today!</h1>
                <p className="margin-bottom-2x">
                    {' '}
                    Please note: You must be 18 years of age or older to create
                    an account. Your{' '}
                    <a
                        className="link privacy-link-top"
                        onClick={() => this.handlePrivacyClicked()}
                    >
                        privacy
                    </a>{' '}
                    is important to us.
                </p>
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={`${classes.form} row padding-bottom-2x`}
                >
                    <div className="split">
                        {this.renderInput({
                            name: 'firstname',
                            label: 'First Name',
                            type: 'text',
                            pattern: '^[a-zA-Z\\s\\.\\-]*$',
                            length: 50,
                        })}
                        {this.renderInput({
                            name: 'lastname',
                            label: 'Last Name',
                            type: 'text',
                            pattern: '^[a-zA-Z\\s\\.\\-]*$',
                            length: 50,
                        })}
                    </div>
                    {this.renderInput({
                        name: 'email',
                        label: 'Email Address',
                        type: 'email',
                        pattern: '^[0-9_a-zA-Z\\s\\.\\-@]*$',
                        length: 50,
                    })}
                    {this.renderInput({
                        name: 'password',
                        label: 'Password',
                        type: 'password',
                        length: 50,
                    })}
                    {this.renderInput({
                        name: 'verifypassword',
                        label: 'Verify Password',
                        type: 'password',
                        length: 50,
                    })}
                    <div className="margin-top-2x">
                        {this.renderCheckbox({
                            isChecked: true,
                            value: 'specialoffer',
                            className: 'checkboxHD',
                            onChange: null,
                            label: 'Please send me emails about special offers, new products and promotions from HarryAndDavid.com',
                        })}
                        <div style={{ marginLeft: '48px' }}>
                            <a
                                className="link privacy-link-bottom"
                                onClick={() => this.handlePrivacyClicked()}
                            >
                                See our Privacy Policy
                            </a>
                        </div>
                    </div>
                    <div className="margin-top-2x">
                        {this.renderButton({
                            label: 'Create Account',
                            className: 'buttonHD submit-btn',
                            onClick: null,
                            type: 'submit',
                        })}
                    </div>
                </form>
            </>
        );
    }
}

CreateAccountForm.defaultProps = {
    handleSubmitCreateAccount: () => {},
    router: {},
};

CreateAccountForm.propTypes = {
    classes: PropTypes.object.isRequired,
    router: PropTypes.object,
    handleSubmitCreateAccount: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitCreateAccount: (data) => dispatch(EventDispatcher.handleSubmitCreateAccount(data)),
    handleOpenModal: (data) => dispatch(EventDispatcher.handleOpenModal(data)),
});

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(CreateAccountForm));
